import { MetaInfo } from 'vue-meta'
import {
  MetaPropertyCharset,
  MetaPropertyEquiv,
  MetaPropertyMicrodata,
  MetaPropertyName,
  MetaPropertyProperty,
  LinkPropertyBase,
  LinkPropertyHref,
  LinkPropertyHrefCallback,
} from 'vue-meta/types/vue-meta'
import { HeaderConfig } from '~/config/headerConfig.types'

const localizedVersions: (
  | LinkPropertyBase
  | LinkPropertyHref
  | LinkPropertyHrefCallback
)[] = [
  {
    rel: 'alternate',
    href: 'https://www.mall.cz',
    hreflang: 'cs-cz',
  },
  {
    rel: 'alternate',
    href: 'https://www.mall.sk',
    hreflang: 'sk-sk',
  },
  {
    rel: 'alternate',
    href: 'https://www.mall.hr',
    hreflang: 'hr-hr',
  },
  {
    rel: 'alternate',
    href: 'https://www.mall.hu',
    hreflang: 'hu-hu',
  },
  {
    rel: 'alternate',
    href: 'https://www.mall.pl',
    hreflang: 'pl-pl',
  },
  {
    rel: 'alternate',
    href: 'https://www.mimovrste.com',
    hreflang: 'sl-si',
  },
]

export const headerConfig = (setting: HeaderConfig): MetaInfo => {
  const getConfigShop = setting?.getConfig?.shopConfig
  const routePatch = setting?.route.fullPath.replace('/', '')

  return {
    titleTemplate: (title) => getHeaderTitleTemplate(title, setting),
    link: [
      {
        href: getConfigShop?.nxtFavIcon,
        rel: 'shortcut icon',
      },
      {
        href: getConfigShop?.metaPublisher,
        rel: 'publisher',
      },
      {
        href: `${getConfigShop?.imgServer}/${getConfigShop?.metaOgImage}`,
        rel: 'previewimage',
        hid: 'previewimage',
      },
      {
        href: '/manifest.json',
        rel: 'manifest',
      },
      ...localizedVersions,
      ...(setting.isBot
        ? [
            {
              href: `${getConfigShop?.metaUrl}${routePatch}`,
              rel: 'canonical',
              hid: 'canonical',
            },
          ]
        : []),
    ],
    meta: filterEmptyMeta([
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      {
        hid: 'description',
        name: 'description',
        content: `${getConfigShop?.title} - ${getConfigShop?.metaDescriptionDefault}`,
      },
      {
        hid: 'robots',
        name: 'robots',
        content: 'all, follow',
      },
      {
        hid: 'og:url',
        property: 'og:url',
        content: `${getConfigShop?.metaUrl}${routePatch}`,
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: `${getConfigShop?.imgServer}/${getConfigShop?.metaOgImage}/500/500/`,
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: `${getConfigShop?.metaDescriptionDefault}`,
      },
      {
        hid: 'fb:admins',
        name: 'fb:admins',
        content: getConfigShop?.metaFbAdmins,
      },
      {
        hid: 'google-site-verification',
        name: 'google-site-verification',
        content: getConfigShop?.metaGSiteVerify,
      },
      {
        hid: 'msvalidate.01',
        name: 'msvalidate.01',
        content: getConfigShop?.metaMSValidate,
      },
      {
        hid: 'url',
        itemprop: 'url',
        content: getConfigShop?.metaUrl,
      },
      {
        hid: 'name',
        itemprop: 'name',
        content: getConfigShop?.title,
      },
      {
        hid: 'theme-color',
        name: 'theme-color',
        content: getConfigShop?.metaThemeColor,
      },
      {
        hid: 'application-name',
        name: 'application-name',
        content: getConfigShop?.metaName,
      },
      {
        hid: 'msapplication-starturl',
        name: 'msapplication-starturl',
        content: getConfigShop?.metaUrl,
      },
      {
        hid: 'msapplication-toolti',
        name: 'msapplication-tooltip',
        content: getConfigShop?.metaMSAppTooltip,
      },
      {
        hid: 'msapplication-navbutton-color',
        name: 'msapplication-navbutton-color',
        content: getConfigShop?.metaMsAppNavBarColor,
      },
      {
        hid: 'copyright',
        name: 'copyright',
        content: getConfigShop?.metaCopyright,
      },
      {
        hid: 'hiring',
        name: 'hiring',
        content: getConfigShop?.metaHiring,
      },
      {
        hid: 'seznam-wmt',
        name: 'seznam-wmt',
        content: getConfigShop?.metaSeznamWmt,
      },
    ]),
  }
}

const filterEmptyMeta = (
  metaData: (
    | MetaPropertyCharset
    | MetaPropertyEquiv
    | MetaPropertyName
    | MetaPropertyMicrodata
    | MetaPropertyProperty
  )[]
) => {
  return metaData.filter((meta) => meta.content)
}

const getHeaderTitleTemplate = (
  title: string,
  setting: HeaderConfig
): string => {
  const metaName = setting?.getConfig?.shopConfig?.metaName
  const $t = setting.translate

  let template = $t(
    'common.txt_client_center_breadcrumb_client_center'
  ) as string

  if (title) {
    template = `${title} - ${template}`
  }

  if (metaName) {
    template += ` | ${metaName}`
  }

  return template
}
